<script lang="ts">
	import { Container, Modal, Button } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import type { DashWidgetEditType } from '../dash-types';
	import DashWidgetReorderCards from '../DashWizard/Components/DashWidgetReorderCards.svelte';
	import { edit } from 'src/stores/ui/edit_lists';
	import { requestAddDashItem } from '../dash-helpers';
	import { params } from 'svelte-spa-router';

	export let editItem: DashWidgetEditType;
	export let showModal = false;

	const onCloseModal = () => {
		showModal = false;
	};

	const onSave = async () => {
		let dashIdFromRoute = $params.id;
		edit.set(false);
		await requestAddDashItem({ ...editItem, dashboardId: dashIdFromRoute });
		onCloseModal();
	};
</script>

<Modal
	on:close={onCloseModal}
	{showModal}
	title={$format('prompt_title_reorder_widget_items', { default: 'Reorder widget items' })}
>
	<Container slot="content" padding="0">
		<DashWidgetReorderCards bind:editItem />
	</Container>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			variant="secondary"
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={onCloseModal}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={onSave}
		>
			{$format('button_save', { default: 'Save' })}
		</Button>
	</div>
</Modal>
